<template>
  <div :class="['relative flex items-center country-select', extraClass]">
    <input aria-label="countryCode" type="text" class="ipt-country-search o-0 absolute w-0" disabled ref="searchRef" @input="searchKey" />
    <div class="side-left" @click="toggleDropdown">
      <div class="relative select bd-1 bd-gray-medium br-6 h-40 pl-16 pr-10 h-40 flex items-center hand">
        <div class="mr-12">
          <div v-if="placeholderCountry && !dataCountry">
            <div class="gray-dark mr-4 fs-14 lh-17">{{ placeholderCountry }}</div>
          </div>
          <div class="flex items-center" v-if="dataCountry">
            <img v-if='dataCountry.flag' :src="resolveImgUrl(dataCountry.flag)" alt="" class="w-20 h-20 mr-8" />
            <div v-if='dataCountry.dial_code' class="black fs-14 lh-17 arial">{{ '+' + dataCountry.dial_code }}</div>
          </div>
        </div>
        <svg
          width="8"
          height="5"
          viewBox="0 0 8 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :style="showDropdown ? 'transform: rotate(180deg);' : ''"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.35032 0L8 0.57401L4 4.10811L0 0.57401L0.649682 0L4 2.96009L7.35032 0Z"
            fill="black"
          />
        </svg>
      </div>
      <div
        class="options custom-option absolute bd-1 bd-gray-medium bg-white gray-dark pt-8 pb-8 br-6 wp-100 mt-8 z-9999 overflow-auto maxh-280 arial"
        v-if="showDropdown"
        v-ClickOutside="closeDropdown"
      >
        <div
          v-for="(item, index) in countries"
          :key="index"
          class="item"
        >
          <a class="flex items-center tl fs-14 lh-17 pl-16 pr-16 pb-8 pt-8 gray-dark hand"
            :class="dataCountry.code === item.code ? 'selected' : ''"
            @click="onChangeOption(item)"
            >
            <img :src="resolveImgUrl(item.flag)" alt="" class="w-20 h-20 mr-14" />
            <span class="black">{{ item.name }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="side-right wp-100">
      <div class="select bd-1 bd-gray-medium br-6 h-40 h-40 flex items-center">
        <input
          type="number"
          class="ipt-country-number black bd-n wp-100 fs-14 outline-0 pl-16 pr-16 hp-100 br-6"
          :placeholder="placeholderPhone"
          autocomplete="tel-national"
          @keypress="allowOnlyNumber"
          @input="handlePhoneValue"
          v-model="phoneVal"
          ref="phoneRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent, nextTick, reactive, watchEffect, watch, onMounted } from 'vue'
import ClickOutside from "~/directives/ClickOutside"
import countryList from '~/components/ui/country-selectbox/country.json'
import { getCookie } from '~/mixins/cookie'
import {assetCDN} from '~/helper/index.js';
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

export default defineComponent({
  name: "CountrySelect",
  directives: {
    ClickOutside
  },
  emits:['update:country','update:phone'],
  props: {
    phone:{
      type: String,
      default: "text"
    },
    placeholderCountry: {
      type: String,
      default: ""
    },
    placeholderPhone: {
      type: String,
      default: ""
    },
    valueDataCountry: {
      type: [String, Object],
      default: null
    },
    showDefault: { // is show empty while API calling?
      type: Boolean,
      default: false
    },
    onlyNumber: { // is allow only number?
      type: Boolean,
      default: false
    },
    extraClass: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const searchRef = ref(null)
    const searchTerm = ref('')
    const phoneRef = ref()
    const phoneVal = ref()
    const showDropdown = ref(false)
    const dataCountry = reactive({
      name: '',
      dial_code: '',
      flag: '',
      code: '',
    })
    const countries = ref(countryList)
    const ASSETS_CDN = assetCDN()
    const generalStore = useGeneralInfoStore()

    watchEffect(()=>{
      phoneVal.value = props.phone
    })

    const toggleDropdown = () =>{
      showDropdown.value = !showDropdown.value
      nextTick(() => {
        const target = document.querySelector(".item .selected")
        if (target) {
          target.scrollIntoViewIfNeeded()
        }
      })
      if(showDropdown.value){
        searchRef.value.focus()
      }
    }

    const searchKey = (e) =>{
      const targets = document.getElementsByClassName("item")
      for (let i = 0; i < targets.length; i++) {
        if(targets[i].innerText.toLowerCase().startsWith(e.target.value.toLowerCase())) {
          targets[i].classList.add("active")
          targets[i].scrollIntoView({ block: 'nearest', inline: 'start' })
        }
      }
      if(e.target.value){
        setTimeout(() => {
          e.target.value = ''
        }, 3000);
      }
    }

    const closeDropdown = () => {
      showDropdown.value = false
    }

    const resolveImgUrl = (path) => {
      // let images = require.context('../../../assets/flags', false, /\.png$|\.svg$/)
      // return images('./' + path)
      // return 'https://s3-cdn.designerjourneys.com/static/flags/' + path
      return `${ASSETS_CDN}/flags/${path}`
    }

    const country_code = getCookie('country_code=')
    if (props.valueDataCountry) {
      dataCountry.name = countries.value.find(item => item.code === props.valueDataCountry).name
      dataCountry.dial_code = countries.value.find(item => item.code === props.valueDataCountry).dial_code
      dataCountry.flag = countries.value.find(item => item.code === props.valueDataCountry).flag
      dataCountry.code = countries.value.find(item => item.code === props.valueDataCountry).code

    } else if(country_code){
      if (!props.showDefault) {
        dataCountry.name = countries.value.find(item => item.code === country_code) ? countries.value.find(item => item.code === country_code).name : 'Vietnam'
        dataCountry.dial_code = countries.value.find(item => item.code === country_code) ? countries.value.find(item => item.code === country_code).dial_code : '84'
        dataCountry.flag = countries.value.find(item => item.code === country_code) ? countries.value.find(item => item.code === country_code).flag : 'vn.svg'
        dataCountry.code = countries.value.find(item => item.code === country_code) ? countries.value.find(item => item.code === country_code).code : 'VN'
      }

      emit("update:country", dataCountry.code)
    } else {
      if (!props.showDefault) {
        dataCountry.name = 'Vietnam'
        dataCountry.dial_code = '84'
        dataCountry.flag = 'vn.svg'
        dataCountry.code = 'VN'
      }

      emit("update:country", dataCountry.code)
    }

    watch(() => props.valueDataCountry, (newVal) => {
      if(newVal) {
        dataCountry.name = countries.value.find(item => item.code === props.valueDataCountry).name
        dataCountry.dial_code = countries.value.find(item => item.code === props.valueDataCountry).dial_code
        dataCountry.flag = countries.value.find(item => item.code === props.valueDataCountry).flag
        dataCountry.code = countries.value.find(item => item.code === props.valueDataCountry).code
      }
    })

    const onChangeOption = item => {
      dataCountry.name = item.name
      dataCountry.dial_code = item.dial_code
      dataCountry.flag = item.flag
      dataCountry.code = item.code
      emit("update:country", dataCountry.code)
      emit('update:phone', phoneVal.value)
    }

    const handlePhoneValue = (e) =>{
      phoneVal.value = e.target.value
      emit('update:phone', phoneVal.value)
    }

    const allowOnlyNumber = ($event) => {
      if (props.onlyNumber) {
        let reg = new RegExp('^[0-9]$');
        if (!reg.test($event.key)) {
          $event.preventDefault();
        }
      }
    }

    onMounted(() => {
      if (!getCookie('country_code')) {
        generalStore.setCallDetect(true)
      }
    })

    return {
      toggleDropdown,
      showDropdown,
      closeDropdown,
      countries,
      resolveImgUrl,
      onChangeOption,
      dataCountry,
      searchRef,
      searchTerm,
      searchKey,
      phoneRef,
      handlePhoneValue,
      allowOnlyNumber,
      phoneVal,
      ASSETS_CDN
    }
  },
})
</script>

<style lang="scss">
.country-select.disabled {
  background-color: $gray-new;
  input {background-color: $gray-new;}
}
.side-left{
  width: 100%;
  max-width: 105px;
  .select{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
    &::after {
      content: '';
      position: absolute;
      top: 5px;
      bottom: 5px;
      width: 1px;
      right: 0;
      background: #F5F5F5;
    }
  }
  .options{
    .item{
      a{
        &.selected{
          background-color: $gray-lighter;
        }
      }
      &:hover{
        a{
          background-color: $gray-lighter;
          &.selected{
            background-color: $gray-lighter;
          }
        }
      }
    }
  }
}
.side-right{
  .select{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}
</style>
